// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1594":"e69a244a","1999":"ef97f693","2224":"1fe51a7c","3521":"b1125ed8","4127":"6b316c53","8437":"ec7e7e7a","9148":"1fe51a7c"}[chunkId] + ".chunk.css";
};